/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React from "react";
function PropertyTableRowName(_ref) {
  var id = _ref.id,
    property = _ref.property;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "table-prop-name-text",
    "data-type": property.type,
    title: property.name
  }, property.name);
}
export default PropertyTableRowName;